import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appAllGetHelpDesk = createAsyncThunk(
	'appHelpDesk/appAllGetHelpDesk',
	async (params = {}) => {
		try {
			const { page = 1, limit = 10, loading = true, hub, sanstha } = params

			let url = `/helpdesk?page=${page}&limit=${limit}`

			if (hub) url += `&hub=${encodeURIComponent(hub)}`
			if (sanstha) url += `&sansthaId=${encodeURIComponent(sanstha)}`

			const response = await httpService.get(url, {}, {}, { loading })

			return response.data.data
		} catch (error) {
			toast.error(error?.message || 'Failed to fetch help desk records')
			throw error
		}
	},
)

export const appUpdateHelpDesk = createAsyncThunk('appHelpDesk/appUpdateHelpDesk', async params => {
	try {
		const response = await httpService.put(
			`/helpdesk/${params.id}`,
			{},
			{
				status: params.status,
				rejectionreason: params.rejectionreason,
			},
		)
		//  console.log(response,"response")
		// toast.success("Sponsor is Updated Successfully");
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appDeleteHelpDesk = createAsyncThunk('appHelpDesk/appDeleteHelpDesk', async id => {
	try {
		const response = await httpService.delete(`/helpdesk/${id}`)
		if (response?.data) {
			response.data.id = id
			toast.success('Requested Hub Deleted Successfully')
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appHelpDeskSlice = createSlice({
	name: 'HelpDesk',
	initialState: {
		helpDesk: [],
		isloder: false,
		paginate: '',
		isdeleted: false,
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appAllGetHelpDesk.pending), (state, action) => {
			state.isloder = true
		})
		builder.addMatcher(isAllOf(appAllGetHelpDesk.fulfilled), (state, action) => {
			state.helpDesk = action.payload
			const paginate = {
				hasNextPage:
					action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
				hasPrevPage: action?.payload?.pagination?.currentPage > 1,
				limit: action?.payload?.pagination?.pageSize,
				nextPage: action?.payload?.pagination?.currentPage + 1,
				page: action?.payload?.pagination?.currentPage,
				pagingCounter:
					(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
					1,
				prevPage: action?.payload?.pagination?.currentPage - 1,
				totalDocs: action?.payload?.pagination?.totalRecords,
				totalPages: action?.payload?.pagination?.totalPages,
			}
			state.paginate = paginate
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appAllGetHelpDesk.rejected), (state, action) => {
			state.isloder = false
		})

		builder.addMatcher(isAllOf(appDeleteHelpDesk.pending), (state, action) => {
			state.isloder = true
			state.isdeleted = false
		})
		builder.addMatcher(isAllOf(appDeleteHelpDesk.fulfilled), (state, action) => {
			state.isdeleted = true
			state.helpDesk?.splice(
				state.helpDesk?.findIndex(data => data?._id === action.payload.id),
				1,
			)
			state.isloder = false
		})
		builder.addMatcher(isAllOf(appDeleteHelpDesk.rejected), state => {
			state.isdeleted = false
			state.isloder = false
		})
	},
})

export default appHelpDeskSlice.reducer
